import { nextTick } from "vue";
import { useGlobalStore } from "@/stores/globalStore";
import useModalActions from "@/composables/store/modal/useModalActions";

export default () => {
  const globalStore = useGlobalStore();
  const { showWalletModal } = useModalActions();
  const handleWalletModalFlow = (handleFormSuccessCallback) => {
    const isMobile = window.innerWidth <= 768;
    const alignContentForModal = isMobile ? "end" : "center";

    showWalletModal({
      alignment: {
        alignContent: alignContentForModal,
      },
      primaryBtnAction() {
        handleFormSuccessCallback();
      },
      secondaryBtnAction() {
        nextTick(() => {
          document.getElementById("walletAddress").focus();
          globalStore.setIsFormLoading(false);
        });
      },
    });
  };

  return {
    handleWalletModalFlow,
  };
};
